type BrandLogoProps = {
  /** `light` = amarelo/claro (fundos escuros); `dark` = cinza (fundos claros) */
  variant?: 'light' | 'dark';
  /** `false` = wordmark completo; `true` = icone M compacto */
  mark?: boolean;
  className?: string;
  height?: number;
};

const SRC = {
  full: {
    light: '/images/momy-logo.webp',
    dark: '/images/momy-logo-dark.webp',
  },
  mark: {
    light: '/images/icon_m_light.webp',
    dark: '/images/icon_m_dark.webp',
  },
} as const;

export function BrandLogo({
  variant = 'dark',
  mark = false,
  className,
  height = 40,
}: BrandLogoProps) {
  return (
    <img
      src={SRC[mark ? 'mark' : 'full'][variant]}
      alt="momy"
      height={height}
      className={className}
      decoding="async"
    />
  );
}

/** Favicon alinhado ao tema: marca clara em tema escuro e vice-versa. */
export function faviconHrefForTheme(theme: 'light' | 'dark'): string {
  return theme === 'dark' ? SRC.mark.light : SRC.mark.dark;
}

export function applyFavicon(theme: 'light' | 'dark'): void {
  const href = faviconHrefForTheme(theme);
  let link = document.querySelector<HTMLLinkElement>('link[rel="icon"][data-momy-favicon]');
  if (!link) {
    link = document.createElement('link');
    link.rel = 'icon';
    link.type = 'image/webp';
    link.dataset.momyFavicon = '1';
    document.head.appendChild(link);
  }
  link.href = href;
}
